<template>
<div :class="['product-item', {'processing' : adding_cart || fetching_more}]" itemscope itemtype="http://schema.org/Product">
    <div class="product-item__inner columns is-mobile">
        <div class="column is-5">
            <div class="product-item__inner__thumb">
                <router-link :to="product.url">
                    <figure>
                        <img itemprop="image" :alt="product.title" v-if="product.thumb" :src="product.thumb.url" />
                    </figure>
                </router-link>
                <span class="product-item__inner__thumb__discount-rate" v-if="product.discount_rate">{{product.discount_rate}}%</span>
                <div class="product-item__actions">
                    <button @click.prevent="quick_add_cart" :class="['product-item__action', {'is-loading': adding_cart}]">
                        <div class="inner">
                            <span class="is-block icon"><i class="fas fa-shopping-cart"></i></span>
                            <span class="is-block icon colour-reversed"><i class="fas fa-shopping-cart"></i></span>
                        </div>
                    </button>
                    <button @click.prevent="fetch_product" :class="['product-item__action', {'is-loading': fetching_more}]">
                        <div class="inner">
                            <span class="is-block icon"><i class="far fa-eye"></i></span>
                            <span class="is-block icon colour-reversed"><i class="far fa-eye"></i></span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
        <div class="column is-7">
            <div class="product-item__content">
                <p class="subtitle is-7"><strong>SKU</strong>: {{product.sku}}</p>
                <p class="title is-6" itemprop="name">
                    <router-link :to="product.url">{{product.title}}</router-link>
                </p>
                <p class="prices subtitle" v-if="!product.special_price">
                    <span class="price" itemprop="price">{{product.price.toDollar()}}</span>
                </p>
                <p class="prices subtitle" v-else>
                    <span class="price" itemprop="price">{{product.special_price.toDollar()}}</span>
                    <strike class="price-was">{{product.price.toDollar()}}</strike>
                </p>
                <div class="content" v-html="product.excerpt"></div>
                <div class="actoins">
                    <router-link class="button is-warning is-small" :to="product.url">View Details</router-link>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name        :   'ProductItem',
    props       :   ['product'],
    data()
    {
        return {
            adding_cart     :   false,
            fetching_more   :   false
        };
    },
    methods     :   {
        quick_add_cart()
        {
            if (this.adding_cart) return false;
            this.adding_cart    =   true;
            let me      =   this,
                data    =   new FormData();

            data.append('csrf', this.$parent.$parent.site_data.session.csrf);
            data.append('id', this.product.id);
            data.append('qty', 1);
            axios.post(
                base_url + endpoints.cart + 'add',
                data
            ).then(this.done_adding).catch(this.error_handling);
        },
        done_adding(resp)
        {
            this.adding_cart    =   false;
            this.$bus.$emit('onCartUpdate', resp.data);
            this.$bus.$emit('onCartConfirm', resp.data);
        },
        error_handling(error)
        {
            this.adding_cart    =   false;
            this.fetching_more  =   false;
        },
        fetch_product()
        {
            if (this.fetching_more) return false;
            this.fetching_more    =   true;
            axios.get(
                base_url + endpoints.product + this.product.id
            ).then((resp) => {
                this.fetching_more  =   false;
                this.$bus.$emit('onProductPreview', resp.data);
            }).catch(this.error_handling);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/elements/ProductItem.vue